// @generated by protoc-gen-connect-es v0.8.4 with parameter "target=ts"
// @generated from file recording/v1/recording_api.proto (package recording.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AnnotateRecordingRequest, AnnotateRecordingResponse, CaptureCameraFrameRequest, CaptureCameraFrameResponse, CreateCameraVerificationFrameRequest, CreateCameraVerificationFrameResponse, CreateCourtVerificationFrameForPracticeRequest, CreateCourtVerificationFrameForPracticeResponse, CreateCourtVerificationFrameRequest, CreateCourtVerificationFrameResponse, CreatePracticeRequest, CreatePracticeResponse, CreateRecordingRequest, CreateRecordingResponse, DeleteAnnotationRequest, DeleteAnnotationResponse, DeleteExportRequest, DeleteExportResponse, DeletePracticeRequest, DeletePracticeResponse, DeleteRecordingRequest, DeleteRecordingResponse, ExportRecordingRequest, ExportRecordingResponse, ExportRecordingZipRequest, ExportRecordingZipResponse, GenerateRecordingHitDatasetRequest, GenerateRecordingHitDatasetResponse, GetPracticeRequest, GetPracticeResponse, GetRecordingRequest, GetRecordingResponse, ListPracticesRequest, ListPracticesResponse, ListRecordingFramesRequest, ListRecordingFramesResponse, ListRecordingsRequest, ListRecordingsResponse, ProcessPracticeRequest, ProcessPracticeResponse, ProcessRecordingRequest, ProcessRecordingResponse, RegeneratePracticeThumbnailRequest, RegeneratePracticeThumbnailResponse, RegenerateRecordingThumbnailRequest, RegenerateRecordingThumbnailResponse, ReProcessPracticeRequest, ReProcessPracticeResponse, ReProcessRecordingRequest, ReProcessRecordingResponse, SendLiveRecordingCommandsRequest, SendLiveRecordingCommandsResponse, StartLiveRecordingRequest, StartLiveRecordingResponse, UpdateAnnotationNameRequest, UpdateAnnotationNameResponse, UpdateExportNameRequest, UpdateExportNameResponse, UpdatePracticeEmptyCourtRequest, UpdatePracticeEmptyCourtResponse, UpdateRecordingEmptyCourtRequest, UpdateRecordingEmptyCourtResponse, UpdateRecordingMatchTypeRequest, UpdateRecordingMatchTypeResponse, UpdateRecordingNameRequest, UpdateRecordingNameResponse, UpdateRecordingNotesRequest, UpdateRecordingNotesResponse, UpdateRecordingPasswordRequest, UpdateRecordingPasswordResponse, UpdateRecordingReportRequest, UpdateRecordingReportResponse, UpdateRecordingScoreRequest, UpdateRecordingScoreResponse, UpdateRecordingSettingsRequest, UpdateRecordingSettingsResponse, UpdateRecordingTagRequest, UpdateRecordingTagResponse, UpdateRecordingTournamentRequest, UpdateRecordingTournamentResponse, UpdateRecordingTournamentStageKeyRequest, UpdateRecordingTournamentStageKeyResponse } from "./recording_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * RecordingAPI service
 *
 * @generated from service recording.v1.RecordingAPI
 */
export const RecordingAPI = {
  typeName: "recording.v1.RecordingAPI",
  methods: {
    /**
     * @generated from rpc recording.v1.RecordingAPI.StartLiveRecording
     */
    startLiveRecording: {
      name: "StartLiveRecording",
      I: StartLiveRecordingRequest,
      O: StartLiveRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CaptureCameraFrame
     */
    captureCameraFrame: {
      name: "CaptureCameraFrame",
      I: CaptureCameraFrameRequest,
      O: CaptureCameraFrameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CreateCameraVerificationFrame
     */
    createCameraVerificationFrame: {
      name: "CreateCameraVerificationFrame",
      I: CreateCameraVerificationFrameRequest,
      O: CreateCameraVerificationFrameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.SendLiveRecordingCommands
     */
    sendLiveRecordingCommands: {
      name: "SendLiveRecordingCommands",
      I: SendLiveRecordingCommandsRequest,
      O: SendLiveRecordingCommandsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CreateRecording
     */
    createRecording: {
      name: "CreateRecording",
      I: CreateRecordingRequest,
      O: CreateRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.RegenerateRecordingThumbnail
     */
    regenerateRecordingThumbnail: {
      name: "RegenerateRecordingThumbnail",
      I: RegenerateRecordingThumbnailRequest,
      O: RegenerateRecordingThumbnailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ProcessRecording
     */
    processRecording: {
      name: "ProcessRecording",
      I: ProcessRecordingRequest,
      O: ProcessRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ReProcessRecording
     */
    reProcessRecording: {
      name: "ReProcessRecording",
      I: ReProcessRecordingRequest,
      O: ReProcessRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CreateCourtVerificationFrame
     */
    createCourtVerificationFrame: {
      name: "CreateCourtVerificationFrame",
      I: CreateCourtVerificationFrameRequest,
      O: CreateCourtVerificationFrameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ListRecordings
     */
    listRecordings: {
      name: "ListRecordings",
      I: ListRecordingsRequest,
      O: ListRecordingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.GetRecording
     */
    getRecording: {
      name: "GetRecording",
      I: GetRecordingRequest,
      O: GetRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.DeleteRecording
     */
    deleteRecording: {
      name: "DeleteRecording",
      I: DeleteRecordingRequest,
      O: DeleteRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ListRecordingFrames
     */
    listRecordingFrames: {
      name: "ListRecordingFrames",
      I: ListRecordingFramesRequest,
      O: ListRecordingFramesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingNotes
     */
    updateRecordingNotes: {
      name: "UpdateRecordingNotes",
      I: UpdateRecordingNotesRequest,
      O: UpdateRecordingNotesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingName
     */
    updateRecordingName: {
      name: "UpdateRecordingName",
      I: UpdateRecordingNameRequest,
      O: UpdateRecordingNameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingMatchType
     */
    updateRecordingMatchType: {
      name: "UpdateRecordingMatchType",
      I: UpdateRecordingMatchTypeRequest,
      O: UpdateRecordingMatchTypeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingEmptyCourt
     */
    updateRecordingEmptyCourt: {
      name: "UpdateRecordingEmptyCourt",
      I: UpdateRecordingEmptyCourtRequest,
      O: UpdateRecordingEmptyCourtResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingReport
     */
    updateRecordingReport: {
      name: "UpdateRecordingReport",
      I: UpdateRecordingReportRequest,
      O: UpdateRecordingReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingPassword
     */
    updateRecordingPassword: {
      name: "UpdateRecordingPassword",
      I: UpdateRecordingPasswordRequest,
      O: UpdateRecordingPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingScore
     */
    updateRecordingScore: {
      name: "UpdateRecordingScore",
      I: UpdateRecordingScoreRequest,
      O: UpdateRecordingScoreResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTag
     */
    updateRecordingTag: {
      name: "UpdateRecordingTag",
      I: UpdateRecordingTagRequest,
      O: UpdateRecordingTagResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingSettings
     */
    updateRecordingSettings: {
      name: "UpdateRecordingSettings",
      I: UpdateRecordingSettingsRequest,
      O: UpdateRecordingSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTournament
     */
    updateRecordingTournament: {
      name: "UpdateRecordingTournament",
      I: UpdateRecordingTournamentRequest,
      O: UpdateRecordingTournamentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTournamentStageKey
     */
    updateRecordingTournamentStageKey: {
      name: "UpdateRecordingTournamentStageKey",
      I: UpdateRecordingTournamentStageKeyRequest,
      O: UpdateRecordingTournamentStageKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.GenerateRecordingHitDataset
     */
    generateRecordingHitDataset: {
      name: "GenerateRecordingHitDataset",
      I: GenerateRecordingHitDatasetRequest,
      O: GenerateRecordingHitDatasetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ExportRecording
     */
    exportRecording: {
      name: "ExportRecording",
      I: ExportRecordingRequest,
      O: ExportRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.DeleteExport
     */
    deleteExport: {
      name: "DeleteExport",
      I: DeleteExportRequest,
      O: DeleteExportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateExportName
     */
    updateExportName: {
      name: "UpdateExportName",
      I: UpdateExportNameRequest,
      O: UpdateExportNameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.AnnotateRecording
     */
    annotateRecording: {
      name: "AnnotateRecording",
      I: AnnotateRecordingRequest,
      O: AnnotateRecordingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.DeleteAnnotation
     */
    deleteAnnotation: {
      name: "DeleteAnnotation",
      I: DeleteAnnotationRequest,
      O: DeleteAnnotationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdateAnnotationName
     */
    updateAnnotationName: {
      name: "UpdateAnnotationName",
      I: UpdateAnnotationNameRequest,
      O: UpdateAnnotationNameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ExportRecordingZip
     */
    exportRecordingZip: {
      name: "ExportRecordingZip",
      I: ExportRecordingZipRequest,
      O: ExportRecordingZipResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CreatePractice
     */
    createPractice: {
      name: "CreatePractice",
      I: CreatePracticeRequest,
      O: CreatePracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.RegeneratePracticeThumbnail
     */
    regeneratePracticeThumbnail: {
      name: "RegeneratePracticeThumbnail",
      I: RegeneratePracticeThumbnailRequest,
      O: RegeneratePracticeThumbnailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ProcessPractice
     */
    processPractice: {
      name: "ProcessPractice",
      I: ProcessPracticeRequest,
      O: ProcessPracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ReProcessPractice
     */
    reProcessPractice: {
      name: "ReProcessPractice",
      I: ReProcessPracticeRequest,
      O: ReProcessPracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.CreateCourtVerificationFrameForPractice
     */
    createCourtVerificationFrameForPractice: {
      name: "CreateCourtVerificationFrameForPractice",
      I: CreateCourtVerificationFrameForPracticeRequest,
      O: CreateCourtVerificationFrameForPracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.ListPractices
     */
    listPractices: {
      name: "ListPractices",
      I: ListPracticesRequest,
      O: ListPracticesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.GetPractice
     */
    getPractice: {
      name: "GetPractice",
      I: GetPracticeRequest,
      O: GetPracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.DeletePractice
     */
    deletePractice: {
      name: "DeletePractice",
      I: DeletePracticeRequest,
      O: DeletePracticeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc recording.v1.RecordingAPI.UpdatePracticeEmptyCourt
     */
    updatePracticeEmptyCourt: {
      name: "UpdatePracticeEmptyCourt",
      I: UpdatePracticeEmptyCourtRequest,
      O: UpdatePracticeEmptyCourtResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

